<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-secondary">
              <div class="box-header with-border">
                <h3 class="box-title"><i class="fa fa-tag mr-5"></i>{{'top_seller_for_storewindow_configuration' | translate}}</h3>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="form-group col-xs-12">
                    <label for="storeSelect">{{'storewindow_store_number' | translate}}:</label>
                    <select class="form-control" id="storeSelect" v-model="selectedFilters.storeNumber" @change="getStoreActions()">
                      <option value="0">Filiale auswählen</option>
                      <option v-for="store in stores" :value="store.store_number" class="normal">{{store.store_number}}</option>
                    </select>
                  </div>
                </div>
                <div class="row hidden" id="selectedStoreContent">
                  <div class="form-group col-xs-12">
                    <hr/>
                    <label for="aktionSelect">{{'storewindow_action' | translate}}:</label>
                    <div class="input-group">
                      <select class="form-control" id="aktionSelect" v-model="selectedStoreAktionId" @change="updateActionFilters()">
                        <option value="-1">Aktion erstellen</option>
                        <option v-for="(action, key) in storeActions" :value="key" class="normal">{{action.str_store_number}} - {{action.aktion_path}} bearbeiten</option>
                      </select>
                      <span class="input-group-btn">
                      <a :href="`https://www.schuhe.de/online-kaufen/store-${selectedFilters.storeNumber}/auswahl-${selectedFilters.path}`" target="_blank" :class="[isUpdate ? '' : 'disabled', 'btn', 'btn-outline', 'btn-flat']"><i class="fa fa-globe"></i></a>
                    </span>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>{{'storewindow_aktion_path' | translate}}:</label>
                    <div v-if="!isUpdate" class="input-group">
                      <span class="input-group-addon">auswahl-</span>
                      <select :class="[filters.paths.length > 0 ? '' : 'disabled', 'form-control']" id="pathSelect" v-model="selectedFilters.path">
                        <option v-for="path in filters.paths" :value="path.name" class="normal">{{path.name}}</option>
                      </select>
                    </div>
                    <div v-else  class="input-group">
                      <span class="input-group-addon">auswahl-</span>
                      <select class="disabled form-control" id="pathSelect" v-model="selectedFilters.path">
                        <option :value="selectedFilters.path" class="normal">{{selectedFilters.path}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>{{'storewindow_search_cat' | translate}}:</label>
                    <div class="input-group col-xs-12">
                      <multiselect v-model="selectedFilters.categories" :options="filters.categories" :close-on-select="false" :clear-on-select="false" :hide-selected="true" placeholder="" label="name" track-by="name" :multiple="true">
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>{{'storewindow_search_brand' | translate}}:</label>
                    <div class="input-group col-xs-12">
                      <multiselect v-model="selectedFilters.brands" :options="filters.brands" :close-on-select="false" :clear-on-select="false" :hide-selected="true" placeholder="" label="name" track-by="name" :multiple="true">
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>{{'storewindow_search_color' | translate}}:</label>
                    <div class="input-group col-xs-12">
                      <multiselect v-model="selectedFilters.colors" :options="filters.colors" :close-on-select="false" :clear-on-select="false" :hide-selected="true" placeholder="" label="name" track-by="name" :multiple="true">
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group col-xs-12">
                    <label>{{'storewindow_comp_model' | translate}}:</label>
                    <textarea placeholder="Bsp: 25351100083; 22453400001" rows="6" class="form-control" v-model="selectedFilters.txt_comp_products_models"></textarea>
                  </div>
                  <div class="form-group col-xs-12">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="selectedFilters.sale">
                        {{'storewindow_show_sale' | translate}}
                      </label>
                    </div>
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="selectedFilters.onlySale">
                        {{'storewindow_show_only_sale' | translate}}
                      </label>
                    </div>
                    <div class="checkbox mt-10">
                      <label>
                        <input type="checkbox" v-model="selectedFilters.isActive">
                        Aktiv
                      </label>
                    </div>
                  </div>
                  <div class="form-group col-xs-12">
                    <hr />
                    <button v-if="isUpdate === true" class="btn btn-info pull-right" @click="createOrUpdateAktion()">
                      <i class="fa fa-save mr-5"></i>Aktion aktualisieren
                    </button>
                    <button v-else class="btn btn-success pull-right" @click="createOrUpdateAktion()">
                      <i class="fa fa-save mr-5"></i>Aktion erstellen
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VueMultiselect from 'vue-multiselect/src/Multiselect'
export default {
  name: 'StoreWindow',
  components: {VueMultiselect},
  data () {
    return {
      alerts: [],
      stores: [],
      storeActions: [],
      selectedStoreAktionId: '-1',
      storeWindowAktionId: 0,
      isUpdate: false,
      filters: {
        categories: [],
        brands: [],
        colors: [],
        paths: [],
        originalPaths: []
      },
      selectedFilters: {
        storeNumber: 0,
        categories: [],
        brands: [],
        colors: [],
        path: '',
        txt_comp_products_models: '',
        sale: false,
        onlySale: false,
        isActive: false
      },
    }
  },
  computed: {
  },
  methods: {
    getData () {
      this.loading = true
      API.get(`accounting/stores`)
        .then(res => {
          this.stores = res.data
          API.get(`statistics/storewindow/filters`)
            .then(response => {
              this.filters = response.data
              this.filters.originalPaths = response.data.paths
              this.loading = false
            })
            .catch(error => {
              let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message], icon: 'icon fa fa-ban'}
              this.$store.commit('pushAlert', alert)
            })
        })
        .catch(error => {
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message], icon: 'icon fa fa-ban'}
          this.$store.commit('pushAlert', alert)
        })
    },
    getStoreActions() {
      API.get(`statistics/storewindow/${this.selectedFilters.storeNumber}/actions`)
        .then(res => {
          this.resetActionFilters(this.selectedFilters.storeNumber)
          if (res.data !== 'Action not found') {
            this.storeActions = res.data
            this.filterActionPath()
          }
          if ($('#selectedStoreContent').hasClass('hidden')) {
            $('#selectedStoreContent').removeClass('hidden')
          }
        })
        .catch(error => {
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message], icon: 'icon fa fa-ban'}
          this.$store.commit('pushAlert', alert)
        })
    },
    resetActionFilters (data) {
      this.storeActions = []
      this.selectedStoreAktionId = '-1'
      this.storeWindowAktionId = 0
      this.isUpdate = false
      this.selectedFilters = {
        storeNumber: data,
        categories: [],
        brands: [],
        colors: [],
        path: '',
        txt_comp_products_models: '',
        sale: false,
        onlySale: false,
        isActive: false
      }
    },
    updateActionFilters() {
      if (this.selectedStoreAktionId === '-1') {
        this.storeWindowAktionId = 0
        this.isUpdate = false
        this.selectedFilters.categories = []
        this.selectedFilters.brands = []
        this.selectedFilters.colors = []
        this.selectedFilters.path = ''
        this.selectedFilters.txt_comp_products_models = ''
        this.selectedFilters.sale = 0
        this.selectedFilters.onlySale = 0
        this.selectedFilters.isActive = 0
      } else {
        this.storeWindowAktionId = this.storeActions[this.selectedStoreAktionId].id
        if (this.storeWindowAktionId > 0) {
          this.isUpdate = true
        }
        this.selectedFilters.categories = (this.storeActions[this.selectedStoreAktionId].str_search_in_cat.length > 0) ? JSON.parse(this.storeActions[this.selectedStoreAktionId].str_search_in_cat) : []
        this.selectedFilters.brands = (this.storeActions[this.selectedStoreAktionId].str_search_in_brand.length > 0) ? JSON.parse(this.storeActions[this.selectedStoreAktionId].str_search_in_brand) : []
        this.selectedFilters.colors = (this.storeActions[this.selectedStoreAktionId].str_search_in_color.length > 0) ? JSON.parse(this.storeActions[this.selectedStoreAktionId].str_search_in_color) : []
        this.selectedFilters.path = this.storeActions[this.selectedStoreAktionId].aktion_path
        this.selectedFilters.txt_comp_products_models = this.storeActions[this.selectedStoreAktionId].txt_comp_products_models
        this.selectedFilters.sale = this.storeActions[this.selectedStoreAktionId].ti_search_in_sale
        this.selectedFilters.onlySale = this.storeActions[this.selectedStoreAktionId].ti_search_just_sale
        this.selectedFilters.isActive = this.storeActions[this.selectedStoreAktionId].ti_active
      }
    },
    createOrUpdateAktion() {
      let data = {
        user: this.$store.getters.user.username,
        str_store_number: this.selectedFilters.storeNumber,
        aktion_path: this.selectedFilters.path,
        ti_active: this.selectedFilters.isActive,
        txt_comp_products_models: this.selectedFilters.txt_comp_products_models,
        str_search_in_cat: JSON.stringify(this.selectedFilters.categories),
        str_search_in_brand: JSON.stringify(this.selectedFilters.brands),
        str_search_in_color: JSON.stringify(this.selectedFilters.colors),
        ti_search_in_sale: this.selectedFilters.sale,
        ti_search_just_sale: this.selectedFilters.onlySale
      }

      if (this.isUpdate) {
        //  update
        API.put(`statistics/storewindow/${this.selectedFilters.storeNumber}/action/${this.storeWindowAktionId}`, data)
          .then(response => {
            let alert = {type: 'success', dismiss: 4, message: 'Die Aktion wurde aktualisiert'}
            this.$store.commit('pushAlert', alert)
          })
          .catch(error => {
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            this.$store.commit('pushAlert', alert)
          })
      } else {
        //  create
        API.post(`statistics/storewindow/${this.selectedFilters.storeNumber}/action`, data)
          .then(response => {
            API.get(`statistics/storewindow/${this.selectedFilters.storeNumber}/actions`)
              .then(res => {
                this.resetActionFilters(this.selectedFilters.storeNumber)
                if (res.data !== 'Action not found') {
                  this.storeActions = res.data
                  this.filterActionPath()
                }
                this.selectedStoreAktionId = this.storeActions.length - 1
                this.updateActionFilters()
              })
          })
          .catch(error => {
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            this.$store.commit('pushAlert', alert)
          })
      }
    },
    filterActionPath () {
      this.filters.paths = Object.assign([], this.filters.originalPaths)
      for (let action = 0; action < this.storeActions.length; action++) {
        for (let filter = 0; filter < this.filters.paths.length; filter++) {
          if (this.storeActions[action].aktion_path === this.filters.paths[filter].name) {
            this.filters.paths.splice(filter, 1)
          }
        }
      }
    },
  },
  mounted () {
    this.getData()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  select option.normal{margin:40px;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.4);background:#202227}
  .is-clickable {
    cursor: pointer;
  }
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
  }
  .multiselect__spinner {
    background: #212228 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 1;
    -webkit-overflow-scrolling: touch;
  }
</style>
<style scoped>
  .alert.alert-message {
    position: fixed;
  }
  .alert-dismissible {
    z-index: 9999;
    position: fixed;
    width: 300px;
    top: 60px;
    right: 20px;
  }

  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Statistics/StoreWindow.vue